import styles from "./styles.module.scss";

// Front End Images
import cssImg from "../../assets/css-2.svg";
import htmlImg from "../../assets/html-2.svg";
import sassImg from "../../assets/sass.svg";
import reactjsImg from "../../assets/reactjs-2.svg";
import javascriptImg from "../../assets/js-2.svg";
import figmaImg from "../../assets/figma2.svg";
import nextJs from "../../assets/nextjs.svg";

import typesImg from "../../assets/typescript-2.svg";

// Back End Images
import nodeImg from "../../assets/node.svg";
import postgreImg from "../../assets/postgresql.svg";
import mysqlImg from "../../assets/mysql.svg";
import dockerImg from "../../assets/docker.svg";
import expressImg from "../../assets/express.svg";

export function MyWorkTools() {
  return (
    <section className={styles.ToolsContainer} id="srollSuave">
      <h2>
        Tecnologias/ferramentas <br /> que eu utilizo ou já utilizei
      </h2>
      <div className={styles.MySkills}>
        <div>
          <h3>Front End Tools</h3>
          <div className={styles.tools}>
            <img src={htmlImg} alt="html" />
            <img src={cssImg} alt="css" />
            <img src={javascriptImg} alt="javascript" />
            <img src={reactjsImg} alt="react" />
            <img src={sassImg} alt="sass" />
            <img src={nextJs} alt="next" />
            <img src={figmaImg} alt="figma" />
          </div>
        </div>
        <div>
          <p className={styles.ordinary}>Em Comum</p>
          <img src={typesImg} alt="" />
        </div>
        <div>
          <h3>Back End Tools</h3>
          <div className={styles.tools}>
            <img src={nodeImg} alt="node" />
            <img src={postgreImg} alt="postgresql" />
            <img src={mysqlImg} alt="mysql" />
            <img src={dockerImg} alt="docker" />
            <img src={expressImg} alt="express" />
          </div>
        </div>
      </div>
    </section>
  );
}
